import React from 'react';
import CabecalhoGrafico from 'components/Windx/CabecalhoGrafico';
import GraficoSH from 'components/Windx/GraficoSH';
import useIsMobile from 'utils/hooks/useIsMobile';

import SemiHorarioMobile from './Mobile';

export default function WindxSemiHorario() {
  const isMobile = useIsMobile();

  if (isMobile) return <SemiHorarioMobile />;

  // WINDX-038 Frente B: wrapper flex container permite cadeia
  // CabecalhoGrafico → __corpo → GraficoSH → ChartComSliders crescer e
  // ocupar area disponivel (sem faixa cinza embaixo). minHeight no
  // GraficoSH mantem fallback de 32rem se ancestral nao propagar altura.
  return (
    <div className="p-4 d-flex flex-column flex-grow-1" style={{ minHeight: 0 }}>
      <CabecalhoGrafico tela="sh">
        <GraficoSH />
      </CabecalhoGrafico>
    </div>
  );
}
